import { useEffect, useState } from 'react'
import { IContactPhone } from '../../../../types/contact';

import { Input, Table, Button } from 'reactstrap';
import { EditIcon } from '../../../common/icons';
import { CheckGroup } from '../../../../hook/useCheckGroup';
import useToggle from '../../../../hook/useToggle';
import PhoneUpdate from './phone-update';
import { GET_ORG_CONTACT_PHONES } from '../../../../graphql/contact-gql';
import { useLazyQuery } from '@apollo/client';
import { IOrg } from '../../../../types/org';
import SpinnerOverlay from '../../../common/spinner/spinner';
import ImgButton from '../../../common/img-button/img-button';
import useAuth from '../../../../hook/useAuth';
import { useFrench } from '../../../french/french-context';

type OrgPhoneProps = {
    org: IOrg;
    checkGroup: CheckGroup<number>;
}

const OrgPhone = (props: OrgPhoneProps) => {
    const {org, checkGroup} = props;
    const { isFrenchTranslator } = useAuth()
    const [frenchState] = useFrench()
    const [contactPhone, setContactPhone] = useState<IContactPhone>()
    const {isOpen: editPhoneOpen, toggle: toogleEditPhone} = useToggle()

    const [getOrgPhones, {loading, data}] = useLazyQuery(GET_ORG_CONTACT_PHONES, {
        onCompleted: (data) => {
            if (data?.org?.contactPhones) {
                checkGroup.init(data.org.contactPhones.map((e: IContactPhone) => e.id))
            }
        }
    })

    useEffect(() => {
        if (org) {
            getOrgPhones({variables: { orgId: org.id }, fetchPolicy: 'network-only'})
        }
    }, [org])

    const editContactPhone = (contactPhone: IContactPhone) => {
        setContactPhone(contactPhone)
        toogleEditPhone()
    }

    return (
        <>
            {loading && <SpinnerOverlay />}
            {data?.org?.contactPhones && (
            <Table striped className="fixed" id="org_phone_numbers">
                <thead>
                    <tr>
                       {!isFrenchTranslator && <th className="icon-column">
                            <span className="sr-only">select phone</span>
                            {data.org.contactPhones.length > 0 && !checkGroup.isEmpty() &&
                                <>
                                    <span id="orgPhoneSelectAllLbl" className="sr-only">Select all</span>
                                    <Input
                                        type="checkbox"
                                        title="Select all"
                                        aria-labelledby="orgPhoneSelectAllLbl"
                                        checked={checkGroup.isAllChecked()}
                                        onChange={checkGroup.onCheckAll}
                                        disabled={!!org.details?.shareLinkId}
                                    />
                                </>
                            }
                        </th>}
                        <th>Phone Type</th>
                        <th>Country Code</th>
                        <th>10-Digit Number</th>
                        <th>Extension</th>
                        <th style={{width: '25%'}}>Description</th>
                        { (!isFrenchTranslator || frenchState.isFrenchChecked) && <th className="edit-column">Edit</th>}
                    </tr>
                </thead>
                <tbody>
                {
                    data.org.contactPhones.length === 0
                    ?
                    <tr><td colSpan={!isFrenchTranslator? 7 : isFrenchTranslator && frenchState.isFrenchChecked?6: 5} style={{textAlign: 'center'}}>No organization phone numbers found.</td></tr>
                    :
                    data.org.contactPhones?.map((contactPhone: IContactPhone, index: number) => {
                        return (
                            <tr key={index}>
                                 {!isFrenchTranslator &&<td>
                                    <Input type="checkbox"
                                        aria-label={'Select phone ' + contactPhone.areaCode + contactPhone.localNumber}
                                        checked={checkGroup.isChecked(contactPhone.id)}
                                        onChange={event => checkGroup.onCheck(event, contactPhone.id)}
                                        disabled={!!org.details?.shareLinkId}
                                    />
                                </td>}
                                <td>{contactPhone.phoneType.label}</td>
                                <td>{contactPhone.countryCode}</td>
                                <td>{contactPhone.areaCode + '-' + contactPhone.localNumber.substring(0,3) + '-' + contactPhone.localNumber.substring(3)}</td>
                                <td>{contactPhone.extension? contactPhone.extension : ""}</td>
                                <td>{contactPhone.description? contactPhone.description : ""}
                                    {contactPhone.descriptionFrench && frenchState.isFrenchChecked && 
                                    <><br /><span lang="fr">{contactPhone.descriptionFrench}</span></>
                                    }
                                </td>
                                {(!isFrenchTranslator || frenchState.isFrenchChecked) && <td>
                                    <ImgButton className="float-end" 
                                        aria-label="Edit phone" 
                                        title="Edit phone" 
                                        onClick={()=>editContactPhone(contactPhone)} 
                                        disabled={!!org.details?.shareLinkId}>
                                        <EditIcon className="edit-pencil"/>
                                    </ImgButton>
                                </td>}
                            </tr>
                        )
                    })
                }
                </tbody>
            </Table>
            )}

            <PhoneUpdate contactPhone={contactPhone} isOpen={editPhoneOpen} toggle={toogleEditPhone}></PhoneUpdate>
        </>
    )
}

export default OrgPhone;
